/* eslint-disable no-plusplus */
/* eslint-disable prefer-template */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/prefer-default-export */
import $ from 'jquery';
import Cookies from 'js-cookie';
import App from './App';

// Zwraca obiekt z elementami linku
App.fn.getParamsFormURL = (url) => {
  let urlObj = url;
  if (urlObj === undefined) {
    urlObj = window.location.search;
  }

  const afterMark = urlObj.split('?')[1];
  if (!afterMark) {
    return {};
  }

  urlObj = afterMark.split('&');

  const b = {};
  for (let i = 0; i < urlObj.length; ++i) {
    const p = urlObj[i].split('=', 2);
    if (p.length === 1) {
      b[p[0]] = '';
    } else {
      b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
    }
  }
  return b;
};

/**
 *   Filters by Piotr Piska
 *   @param funcOnSubmit funkcja nadpisujaca domyślną funkcję Ajax
 *   @param funcActionCall Callback wywołujący eventy na przyciski
 *   @param funcAjaxLoad Callback na domyślne ajaxowe filtry
 *   @param formSelector selector dla klasy formularza
 *   @param getQuantity włącza/wyłącza pobieranie ilości elementów filtra
 */
export const Filters = function Filters(params) {
  const self = this;
  this.params = params;
  this.isFilterRange = document.querySelector('.filters__content.--range');

  /**
   * @param getString Link do zapytania
   */
  this.getAsyncData = async (getString) => {
    const data = await $.get(getString);
    return data;
  };

  /**
   *   Funkcja przypisuje do finalnego forma dane z zaznaczonych inputów
   *   @param event javascriptowy event
   */
  this.setInputValue = (target) => {
    const { id } = target.dataset;

    const list = document.querySelectorAll(`input[data-id="${id}"]:checked`);
    const data = [...list].map((element) => element.value).join(',');

    document.querySelector(`#${id}_input`).value = data;
  };

  /**
   * Funkcja ustawia quantity w filtrach
   */
  this.setLabeLsQuantity = async () => {
    const data = await this.getAsyncData(`/search.php?${this.serialize()}&getProductXML=true&xmlType=filtering`);

    if (!data) {
      return false;
    }

    const filters = data.querySelectorAll('filter');
    [...filters].forEach((filter) => {
      const { type } = filter.attributes;
      let id = filter.id.replace(/\[(.*?)\]/g, '$1');
      let filterExpand = document.querySelector(`#${id}_expand`);

      if (type.value === 'dual') {
        id = 'filter_dual';
        filterExpand = document.querySelector('#filter_dual_expand');
      }

      if (filterExpand && id !== 'filter_text') {
        const items = filter.querySelectorAll('item');

        if (items.length) {
          [...items].forEach((item) => {
            const { value, quantity } = item.attributes;
            // Musi być z + ponieważ na template literal się wysypuje i nie widzi elementów DOM
            // eslint-disable-next-line prefer-template
            const selector = 'label[for="' + id + '_' + value.value + '"] .--quantity';
            const quantityElement = filterExpand.querySelector(selector);

            console.log(id, quantityElement, quantity);

            if (quantityElement) {
              if (quantity) {
                quantityElement.classList.remove('d-none');
                quantityElement.innerHTML = quantity.value;
              } else {
                quantityElement.classList.add('d-none');
                quantityElement.innerHTML = 0;
              }
            }
          });
        }
      }
    });
  };

  /**
   * Funkcja ustawiająca wartość inputa filter_price przy zmianie wartości inputFromId lub inputToId
   * @param inputFromId id inputa z wartością OD
   * @param inputToId id inputa z wartością DO
   */
  this.getPriceRange = (inputFromId = '#PriceRangeFrom', inputToId = '#PriceRangeTo') => {
    const from = document.querySelector(inputFromId);
    const to = document.querySelector(inputToId);

    return `${from.value}-${to.value}`;
  };

  /**
   *   Funkcja zwraca string danych z form do zapytania ajax
   *   @param selector selektor klasy html do serializowania, domyślnie: .__serialize
   */
  this.serialize = (selector = '.__serialize') => {
    const data = this.filtersForm.querySelectorAll(selector);

    return [...data]
      .filter((input) => {
        if (input.type === 'checkbox') return input.checked;
        return input.value;
      })
      .map((input) => `${input.name}=${input.value}`)
      .join('&');
  };

  /**
   * Funkcja zmieniająca historię w przeglądarce
   * @param link link do wklejenia w przeglądarce
   */
  this.pushHistory = (link) => {
    history.pushState({}, null, link);
  };

  /**
   *   Funkcjia wykonywana przed wysłaniem danych na serwer, przydatna w przypadku AJAX
   *   @param event javascriptowy event
   */
  this.onSubmit = async (event) => {
    event.preventDefault();

    const body = document.querySelector('body');
    body.classList.add('load-content');
    const { action } = this.filtersForm.attributes;
    const serialize = this.serialize();
    const reg = new RegExp(/\?/g);
    let link = `${action.value}`;
    if (reg.test(action.value)) {
      if (serialize) {
        link += `&${serialize}`;
      }
    } else {
      link += `?${serialize}`;
    }

    const data = await this.getAsyncData(`${link}&set_render=content,aside`);
    const doc = new DOMParser().parseFromString(data, 'text/html');

    const search = document.querySelector('.search');
    const nextPage = document.querySelector('.search__next-page');
    const activeFilters = document.querySelector('#filter_list');

    const newsearch = doc.querySelector('.search');
    const newnextPage = doc.querySelector('.search__next-page');
    const newActiveFilters = doc.querySelector('#filter_list');

    search.innerHTML = newsearch.innerHTML;
    nextPage.innerHTML = newnextPage.innerHTML;
    if (!activeFilters) {
      if (newActiveFilters) {
        search.before(newActiveFilters);
      }
    } else {
      if (newActiveFilters) {
        activeFilters.innerHTML = newActiveFilters.innerHTML;
      } else {
        activeFilters.remove();
      }
    }

    this.pushHistory(link);
    this.callbackAjaxLoad();

    body.classList.remove('load-content');
  };

  // Zapisuje w cookies informację o rozwijanych listach któe są ukryte
  this.setVisibleExpand = () => {
    const notExpand = document.querySelectorAll('.--not-expanded');
    if (!notExpand.length) {
      Cookies.set('filterHidden', '', { expires: 355 });
      return false;
    }
    const notExpanded = [...notExpand].map((node) => node.nextSibling.id);
    Cookies.set('filterHidden', notExpanded, { expires: 355 });
  };

  // odczytuje z cookies któe lsity są ukryte i je ukrywa
  this.getVisibleExpand = () => {
    const notExpanded = Cookies.get('filterHidden');
    if (notExpanded) {
      notExpanded.split(',').forEach((id) => {
        const node = document.querySelector('#' + id);
        if (node !== null) {
          const nodeHeader = node.previousSibling;
          node.style.display = 'none';
          nodeHeader.classList.add('--not-expanded');
        }
      });
    }
  };

  /**
   *   Funkcja uruchamiajaca przypisywanie eventów
   */
  this.start = () => {
    const { getQuantity } = this.params;
    if (this.callbackAjaxLoad) {
      $(this.filtersForm).off('submit').on('submit', this.onSubmit);
    }

    $(this.filtersInputs)
      .off('change')
      .on('change', (event) => {
        const { target } = event;
        if (target.dataset.id !== undefined) {
          this.setInputValue(target);
        }
        if (getQuantity) {
          this.setLabeLsQuantity();
        }
      });
    $('#PriceRangeFrom, #PriceRangeTo').on('change', () => {
      const dest = document.querySelector('#filter_price_input');
      dest.value = self.getPriceRange();
    });

    if (this.urlParameters.filter_nextday) {
      $('#filter_nextday_form').prop('checked', true);
    }
    if (this.urlParameters.filter_sameday) {
      $('#filter_sameday_form').prop('checked', true);
    }
    if (this.actionsCall) this.actionsCall();
    // $('.filters__toggler:not(.--not-expandable)').on('click', () => this.setVisibleExpand());

    // this.getVisibleExpand();
  };

  // INIT
  this.init = ({ funcOnSubmit, funcActionCall, funcAjaxLoad, formSelector }) => {
    if (funcOnSubmit) {
      this.onSubmit = funcOnSubmit;
    }
    this.actionsCall = funcActionCall || null;
    this.callbackAjaxLoad = funcAjaxLoad || null;
    this.filtersForm = formSelector ? document.querySelector(formSelector) : document.querySelector('.filters__form');
    this.filtersInputs = this.filtersForm.querySelectorAll('input[type="checkbox"]');
    this.urlParameters = App.fn.getParamsFormURL();

    this.start();
  };

  return this.init(params);
};
